<h1>{{ (staff$ | async)?.firstName }} {{ (staff$ | async)?.lastName }}</h1>
<staff-form [loading]="loading$ | async"
  [staff]="staff$ | async"
  [disabled]="(isOwnAccount$ | async) || !(admin$ | async)"
  (submitted)="submitStaff($event)"></staff-form>
<p *ngIf="!(admin$ | async)">You do not have permission to modify team members</p>
<p *ngIf="(admin$ | async) && (isOwnAccount$ | async)">You can not modify your own account</p>